import styled from 'styled-components';

import { CarouselSectionPaginationWrapperStyled } from './CarouselSectionPagination.types';

export const CarouselSectionPaginationWrapper = styled.div<CarouselSectionPaginationWrapperStyled>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-inline: 3em;

  ${({ theme }) => theme.mediaQuery.xl} {
    justify-content: center;
    gap: 3rem;
    padding: 0;
  }

  .custom-swiper-pagination {
    display: flex;
    align-items: center;

    .swiper-pagination-bullet-active {
      ${({ paginationBackgroundColor }) =>
        paginationBackgroundColor ? `background-color: ${paginationBackgroundColor};` : ''}
    }
  }
`;
